import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Unlock from '../Unlock/Unlock.vue';
import { parseTemplate } from '@/util';
export default {
  components: {
    Unlock: Unlock
  },
  data: function data() {
    return {};
  },
  computed: {
    starList: function starList() {
      return this.$store.getters.starList;
    },
    notice: function notice() {
      var _this$starList$, _this$starList$2, _this$starList$3;

      var noticeConfig = window.setting.道具配置.明星榜公告;
      var data = {
        n1: (_this$starList$ = this.starList[0]) === null || _this$starList$ === void 0 ? void 0 : _this$starList$.明星名字,
        n2: (_this$starList$2 = this.starList[1]) === null || _this$starList$2 === void 0 ? void 0 : _this$starList$2.明星名字,
        n3: (_this$starList$3 = this.starList[2]) === null || _this$starList$3 === void 0 ? void 0 : _this$starList$3.明星名字
      };
      var notice = parseTemplate(noticeConfig.截止前, data);

      if (this.isPropsEnd) {
        notice = parseTemplate(noticeConfig.截止后, data) || notice;
      }

      return notice;
    },
    supportList: function supportList() {
      return this.$store.state.supportList || [];
    },
    completeTaskCount: function completeTaskCount() {
      var lookTaskInfo = this.$store.state.lookTaskInfo; // eslint-disable-next-line camelcase

      var count = ((lookTaskInfo === null || lookTaskInfo === void 0 ? void 0 : lookTaskInfo.left_num) || 0) + ((lookTaskInfo === null || lookTaskInfo === void 0 ? void 0 : lookTaskInfo.use_num) || 0);
      return count > 10 ? 10 : count;
    }
  },
  watch: {
    starList: function starList() {
      this.initLottie();
    }
  },
  methods: {
    bulletinClick: function bulletinClick() {
      if (this.isPropsEnd) {
        this.eventBus.$emit('showActorListPop');
      }
    },
    toGetProps: function toGetProps() {
      var url = window.setting.道具配置.观看地址;
      this.openUrl(url);
    },
    initLottie: function initLottie() {
      var _this = this;

      this.starList.forEach(function (star, index) {
        var key = "star".concat(star.id);

        if (index < 3) {
          if (!_this[key]) {
            var params = {
              container: _this.$refs[key][0],
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: 'https://m.film.qq.com/vip-activity/lxky/static/lottie/up-particle/data.json'
            };
            _this[key] = window.bodymovin.loadAnimation(params);

            _this[key].addEventListener('data_ready', function () {
              _this[key].play();
            });
          }
        } else {
          if (_this[key]) {
            _this[key].stop();
          }
        }
      });
    }
  }
};